import React, { useEffect } from 'react'
import { AdvisoryReportAtom } from '../../../State/Advisory/AdvisoryReport.Atom';
import { useRecoilValue } from 'recoil';
import { useHistory } from 'react-router-dom';

export const AdvisorReport = () => {
    const selectedReport = useRecoilValue(AdvisoryReportAtom);
    const history = useHistory();
    useEffect(() => {
        if (selectedReport.id === -1) {
            history.push('/advisory/clientRegistrations');
        }

    }, [selectedReport.id])

    return (
        <div>AdvisorReport - {selectedReport.id}</div>
    )
}

